module.exports = __webpack_public_path__ + "img/ReducingDistance.549f3ef.svg";